import { Stack, Button} from '@mui/material';
import Modal from '../../../Tools/Modal.js';

export default function Actions({open, onClose, enrollment, onPay, onComplete, onOwnerChange, onDelete}){

    const id = enrollment?.id;


    return enrollment && 
    
    <Modal open={open} title='Inscription' onClose={onClose} noActions>

        <Stack direction='column' spacing={1}>

            <p>{enrollment?.course?.title}</p>

            {!enrollment.completed && 
                <Button onClick={() => onComplete(id)}>Marquer comme terminée</Button>
            }

            <Button onClick={() => onOwnerChange(id)}>Changer de compte</Button>

            <Button color='error' onClick={() => onDelete(id)}>Supprimer</Button>

        </Stack>

    </Modal>
}

